(() => {
  if (customElements.get('pdp-progress-chart')) return;
  customElements.define('pdp-progress-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.started || !('IntersectionObserver' in window)) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.bars = [...this.querySelectorAll('.rf-track i')];
      this.cancelMotion = () => { if (this.motion.matches) this.bars.forEach(bar => bar.getAnimations().forEach(animation => animation.cancel())); };
      this.motion.addEventListener('change', this.cancelMotion);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.started = true;
        if (this.motion.matches) return;
        this.bars.forEach((bar, i) => {
          if (typeof bar.animate === 'function') bar.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}], {duration:700, delay:i*220, easing:'cubic-bezier(.22,.61,.36,1)', fill:'backwards'});
        });
      }, {threshold:.65});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.cancelMotion);
      this.bars?.forEach(bar => bar.getAnimations().forEach(animation => animation.cancel()));
    }
  });
})();
